<template>
  <form :action="formAction" class="m-search-box p-top p-bottom">
    <div class="g g-no-gutters align-v-center">
      <div class="m-search-box g__col-12 g__col-11@medium g g--no-gutters align-v-center">
        <label :for="id" class="u-screen-reader-only">Enter search keywords</label>
        <input
          :id="id"
          ref="searchInput"
          class="input"
          type="text"
          name="s"
          value=""
          placeholder="Search this site"
        />
        <button type="submit" class="m-search-box--btn m-search-box--btn-search">
          <svg height="24" width="24" viewBox="0 0 24 24">
            <use xlink:href="#icon-search" />
          </svg>
          <span class="u-screen-reader-only">Go to results</span>
        </button>
        <button type="button" class="m-search-box--btn m-search-box--btn-close" @click="close">
          <svg height="24" width="24" viewBox="0 0 24 24">
            <use xlink:href="#icon-close" />
          </svg>
          <span class="u-screen-reader-only">Close search</span>
        </button>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      formAction: window.location.origin + "/" + window.location.pathname.split("/")[1] + "/",
    };
  },
  computed: {
    id() {
      return `search-${Math.random(9999)}`;
    },
  },
  created() {
    this.$nextTick(this.triggerFocus);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    triggerFocus() {
      this.$refs.searchInput.focus();
    },
    handleSubmit() {
      // Handle form submission if needed
    }
  },
};
</script>
